// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feed-list__item{border-bottom:1px solid #ececec}.feed-list__item:last-child{border-bottom:none}.feed-list__date-group{position:relative}.feed-list__date-delimiter{position:sticky;left:0;top:0;background-color:#fafafa;border:1px solid #ececec;color:#b0b0b0;font-size:13px;line-height:20px;text-align:center;z-index:3;padding:6px 6px 4px}html.view_mobile .feed-list__date-delimiter{border-right:none;border-left:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
